// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Comment-cls1___ea7cca6bf3666dcc827{/*!*/}.Comment-cls2___2762eb56eec469f4914{display:flex;align-items:center;grid-gap:6px;gap:6px;max-height:20px}.Comment-cls2___2762eb56eec469f4914>:last-child{display:none}@media(min-width: 375px){.Comment-cls2___2762eb56eec469f4914>:last-child{display:block}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Comment-cls1___ea7cca6bf3666dcc827",
	"cls2": "Comment-cls2___2762eb56eec469f4914 Comment-cls1___ea7cca6bf3666dcc827"
};
export default ___CSS_LOADER_EXPORT___;
